import { render } from "./ReplyList.vue?vue&type=template&id=6a18b92e&ts=true"
import script from "./ReplyList.vue?vue&type=script&lang=ts&setup=true"
export * from "./ReplyList.vue?vue&type=script&lang=ts&setup=true"

import "./ReplyList.vue?vue&type=style&index=0&id=6a18b92e&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/communityTalk/reply/ReplyList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6a18b92e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6a18b92e', __exports__)) {
    api.reload('6a18b92e', __exports__)
  }
  
  module.hot.accept("./ReplyList.vue?vue&type=template&id=6a18b92e&ts=true", () => {
    api.rerender('6a18b92e', render)
  })

}


export default __exports__